import { render, staticRenderFns } from "./BestBetProp.vue?vue&type=template&id=62449b84&scoped=true"
import script from "./BestBetProp.vue?vue&type=script&lang=js"
export * from "./BestBetProp.vue?vue&type=script&lang=js"
import style0 from "./BestBetProp.vue?vue&type=style&index=0&id=62449b84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62449b84",
  null
  
)

export default component.exports